import { TYPE_NUMBER } from './input-types';

export const id = 'weight';
export const apiKey = 'OrderWeight';
export const type = TYPE_NUMBER;

export const weight = {
  id,
  apiKey,
  type,
};
